<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="1200px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="福袋类型" prop="type" class="width100">
        <el-select v-model="form.type" placeholder="请选择福袋类型" @change="handleTypeChange">
          <el-option label="商品福袋" :value="1"></el-option>
          <el-option label="零售价福袋" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="抽奖分配" prop="getType" class="width100">
        <el-select v-model="form.getType" placeholder="请选择分配类型" @change="handleDistributionChange">
          <el-option label="随机" :value="1"></el-option>
          <el-option label="指定人中奖" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <!-- 随机抽奖时的抽奖权限和重复中奖设置 -->
      <template v-if="form.getType === 1">
        <el-form-item label="抽奖权限" prop="levelIdsWinning" class="width100">
          <el-checkbox-group v-model="form.selectedIdentityIds" @change="handleIdentitySelectionChange">
            <el-checkbox-button
              v-for="identityItem in identityList"
              :key="identityItem.id"
              :label="identityItem.id"
            >
              {{ identityItem.name }}
            </el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="重复中奖" prop="isCanRepeatWinning" class="width100">
          <el-switch
            v-model="form.isCanRepeatWinning"
            :active-value="1"
            :inactive-value="0"
            active-text="允许"
            inactive-text="不允许"
          ></el-switch>
        </el-form-item>
      </template>

      <el-form-item v-if="form.type === 1 && !goodsCatalogReady" label="商品目录" class="width100">
        <span v-if="sysGoodsLoading || (!sysGoodsLoaded && !sysGoodsLoadError)" role="status">
          <i class="el-icon-loading"></i> 商品目录加载中，请稍候
        </span>
        <template v-else-if="sysGoodsLoadError">
          <span class="form-tip" role="alert">{{ sysGoodsLoadError }}</span>
          <el-button type="text" style="margin-left: 12px" @click="getSysGoods">重试</el-button>
        </template>
        <template v-else>
          <span role="status">暂无可用商品</span>
          <el-button type="text" style="margin-left: 12px" @click="getSysGoods">重新加载</el-button>
        </template>
      </el-form-item>

      <!-- 商品福袋 -->
      <el-form-item v-if="form.type === 1 && form.getType !== 2" label="福袋商品" prop="items" class="width100 is-required">
        <div class="table-list mt20">
          <div class="spec-head">
            <div class="sp-col">商品</div>
            <div class="sp-col">规格</div>
            <div class="sp-col">抽奖库存</div>
            <div class="sp-col">操作</div>
          </div>
          <div class="spec-item" v-for="(item, idx) in form.items" :key="idx">
            <el-form-item class="sp-col" :prop="`items[${idx}].goodsId`" label-width="0" :rules="{required: true,message: '请选择',trigger: 'change'}">
              <el-select v-model="item.goodsId" placeholder="请选择" filterable :disabled="!goodsCatalogReady" :loading="sysGoodsLoading" loading-text="商品目录加载中" no-data-text="暂无可用商品" @change="handleChange(item)">
                <el-option v-for="it in sysGoods" :key="it.id" :label="it.name" :value="it.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sp-col" :prop="`items[${idx}].combineId`" label-width="0" :rules="{required: true,message: '请选择',trigger: 'change',}">
              <span v-if="item.specArr && item.specArr.length === 1" class="spec-text">{{ item.productSpec || '无规格值' }}</span>
              <el-select v-else v-model="item.combineId" placeholder="请选择规格" :disabled="!goodsCatalogReady" @change="handleChangeSpec(item)">
                <el-option v-for="it in item.specArr" :key="it.id" :label="`${it.spec || '无规格值'}(${it.jushuitanCode})`" :value="it.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sp-col" :prop="`items[${idx}].totalCount`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'change',}">
              <el-input v-model="item.totalCount" placeholder="请输入抽奖库存" @input="calculateTotalAmount" />
            </el-form-item>
            <div class="sp-col oper-icon">
              <i class="el-icon-minus" @click="handleDeleteItem(idx)" v-if="form.items.length > 1"></i>
              <i class="el-icon-plus" @click="handleAddItem"></i>
            </div>
          </div>
        </div>
      </el-form-item>

      <!-- 随机中奖 - 零售价福袋 -->
      <template v-if="form.getType === 1 && form.type === 2">
        <!-- <el-form-item label="中奖名额" prop="totalUserCount" class="width100">
          <el-input v-model="form.totalUserCount" placeholder="请输入中奖名额" @change="calculateTotalAmount" />
        </el-form-item> -->
        
        <el-form-item label="中奖金额" prop="prizeAmounts" class="width100 is-required">
          <div class="table-list mt20">
            <div class="spec-head">
              <div class="sp-col">中奖零售价</div>
              <div class="sp-col">中奖名额</div>
              <div class="sp-col">操作</div>
            </div>
            <div class="spec-item" v-for="(item, idx) in form.prizeAmounts" :key="idx">
              <el-form-item class="sp-col" :prop="`prizeAmounts[${idx}].amount`" label-width="0" :rules="{required: true,message: '请输入',trigger: 'change'}">
                <el-input v-model="item.amount" placeholder="请输入" @change="calculateTotalAmount" />
              </el-form-item>
              <el-form-item class="sp-col" :prop="`prizeAmounts[${idx}].count`" label-width="0" :rules="{required: true,message: '请输入',trigger: 'change'}">
                <el-input v-model="item.count" placeholder="请输入" @change="calculateTotalAmount" />
              </el-form-item>
              <div class="sp-col oper-icon">
                <i class="el-icon-minus" @click="handleDeletePrizeAmount(idx)" v-if="form.prizeAmounts.length > 1"></i>
                <i class="el-icon-plus" @click="handleAddPrizeAmount"></i>
              </div>
            </div>
          </div>
        </el-form-item>
      </template>

      <!-- 指定人中奖 - 零售价福袋 -->
      <el-form-item v-if="form.getType === 2 && form.type === 2" label="中奖金额" prop="winners" class="width100 is-required">
        <div class="table-list mt20">
          <div class="spec-head">
            <div class="sp-col">身份</div>
            <div class="sp-col">中奖人</div>
            <div class="sp-col">中奖零售价</div>
            <div class="sp-col">操作</div>
          </div>
          <div class="spec-item" v-for="(item, idx) in form.winners" :key="idx">
            <el-form-item class="sp-col" :prop="`winners[${idx}].identityId`" label-width="0" :rules="{required: true,message: '请选择',trigger: 'change'}">
              <el-select v-model="item.identityId" placeholder="请选择身份" clearable size="small" @change="handleWinnerIdentityChange(item, idx)">
                <el-option v-for="identityItem in identityList" :key="identityItem.id" :label="identityItem.name" :value="identityItem.level"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sp-col" :prop="`winners[${idx}].designatedUserId`" label-width="0" :rules="{required: true,message: '请选择',trigger: 'change'}">
              <el-select 
                v-model="item.selectedUsers" 
                placeholder="请输入姓名/手机号" 
                multiple
                remote
                :remote-method="(query) => searchWinnerUser(query, idx)"
                :loading="item.searchLoading"
                filterable
                clearable
                size="small"
                :disabled="!item.identityId"
                @change="handleWinnerUsersChange(item, idx)">
                <el-option
                  v-for="(userOption, userIndex) in item.userOptions"
                  :key="userIndex"
                  :label="userOption.value"
                  :value="userOption">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sp-col" :prop="`winners[${idx}].xdbAmount`" label-width="0" :rules="{required: true,message: '请输入',trigger: 'change'}">
              <el-input v-model="item.xdbAmount" placeholder="请输入" @change="calculateTotalAmount" />
            </el-form-item>
            <div class="sp-col oper-icon">
              <i class="el-icon-minus" @click="handleDeleteWinner(idx)" v-if="form.winners.length > 1"></i>
              <i class="el-icon-plus" @click="handleAddWinner"></i>
            </div>
          </div>
        </div>
      </el-form-item>

      <!-- 商品福袋的指定人中奖 -->
      <el-form-item v-if="form.getType === 2 && form.type === 1" label="中奖名额" prop="winners" class="width100 is-required">
        <div class="table-list mt20">
          <div class="spec-head">
            <div class="sp-col">身份</div>
            <div class="sp-col">中奖人</div>
            <div class="sp-col">商品</div>
            <div class="sp-col">规格</div>
            <div class="sp-col">操作</div>
          </div>
          <div class="spec-item" v-for="(item, idx) in form.winners" :key="idx">
            <el-form-item class="sp-col" :prop="`winners[${idx}].identityId`" label-width="0" :rules="{required: true,message: '请选择',trigger: 'change'}">
              <el-select v-model="item.identityId" placeholder="请选择身份" clearable size="small" @change="handleWinnerIdentityChange(item, idx)">
                <el-option v-for="identityItem in identityList" :key="identityItem.id" :label="identityItem.name" :value="identityItem.level"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sp-col" :prop="`winners[${idx}].designatedUserId`" label-width="0" :rules="{required: true,message: '请选择',trigger: 'change'}">
              <el-select 
                v-model="item.selectedUsers" 
                placeholder="请输入姓名/手机号" 
                multiple
                remote
                :remote-method="(query) => searchWinnerUser(query, idx)"
                :loading="item.searchLoading"
                filterable
                clearable
                size="small"
                :disabled="!item.identityId"
                @change="handleWinnerUsersChange(item, idx)">
                <el-option
                  v-for="(userOption, userIndex) in item.userOptions"
                  :key="userIndex"
                  :label="userOption.value"
                  :value="userOption">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sp-col" :prop="`winners[${idx}].goodsId`" label-width="0" :rules="{required: true,message: '请选择',trigger: 'change'}">
              <el-select v-model="item.goodsId" placeholder="请选择" filterable :disabled="!goodsCatalogReady" :loading="sysGoodsLoading" loading-text="商品目录加载中" no-data-text="暂无可用商品" @change="handleWinnerGoodsChange(item)">
                <el-option v-for="it in sysGoods" :key="it.id" :label="it.name" :value="it.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sp-col" :prop="`winners[${idx}].combineId`" label-width="0" :rules="{required: true,message: '请选择',trigger: 'change'}">
              <span v-if="item.specArr && item.specArr.length === 1" class="spec-text">{{ item.productSpec || '无规格值' }}</span>
              <el-select v-else v-model="item.combineId" placeholder="请选择规格" :disabled="!goodsCatalogReady" @change="handleWinnerSpecChange(item)">
                <el-option v-for="it in item.specArr" :key="it.id" :label="`${it.spec || '无规格值'}(${it.jushuitanCode})`" :value="it.id"></el-option>
              </el-select>
            </el-form-item>
            <div class="sp-col oper-icon">
              <i class="el-icon-minus" @click="handleDeleteWinner(idx)" v-if="form.winners.length > 1"></i>
              <i class="el-icon-plus" @click="handleAddWinner"></i>
            </div>
          </div>
        </div>
      </el-form-item>

      <!-- 中奖金额（只读） -->
      <el-form-item label="中奖金额" prop="totalXdbAmount" class="width100" v-if="form.type === 2">
        <el-input v-model="form.totalXdbAmount" :placeholder="form.getType === 1 ? '根据中奖零售价*中奖名额累加算出' : '根据中奖名额读出'" disabled />
      </el-form-item>

      <!-- 抽奖门槛 -->
      <el-form-item label="抽奖门槛" prop="lookTime" class="width100">
        <el-input v-model="form.lookTime" placeholder="请输入抽奖门槛（用户需要达到观看直播时长）">
          <template slot="append">分钟</template>
        </el-input>
        <span class="form-tip">不输入等于不设置,等于进入直播间就可以参与</span>
      </el-form-item>

      <!-- 抽奖时间 -->
      <el-form-item label="抽奖时间" prop="signUpFewMinuteStart" class="width100">
        <el-input v-model="form.signUpFewMinuteStart" placeholder="请输入抽奖时间">
          <template slot="append">分钟</template>
        </el-input>
        <span class="form-tip">不输入等于不设置,立马发放福袋</span>
      </el-form-item>

      <!-- 开奖时间 -->
      <el-form-item label="开奖时间" prop="drawFewMinuteStart" class="width100">
        <el-input v-model="form.drawFewMinuteStart" placeholder="请输入开奖时间">
          <template slot="append">分钟</template>
        </el-input>
      </el-form-item>
      
      <!-- 开奖口令 -->
      <el-form-item label="开奖口令" prop="blessings" class="width100">
        <el-input v-model="form.blessings" placeholder="请输入开奖口令"></el-input>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" :disabled="form.type === 1 && !goodsCatalogReady" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
import liveBlessingBagApi from '@/api/live/liveBlessingBag'
import sysGoodsApi from '@/api/sys/sysGoods'
import liveManageApi from '@/api/live/liveManage'
import customerApi from '@/api/technical/customer'
function initFormBean() {
  const formBean = {
    type: 1, // 1商品福袋,2零售价福袋
    getType: 1, // 1随机,2指定人中奖
    items: [{ goodsId: '', combineId: '', totalCount: 0}], // 商品福袋
    winners: [{ 
      identityId: '',
      selectedUser: null,
      selectedUsers: [], // 多选用户数组
      userOptions: [],
      searchLoading: false,
      searchKeyword: '',
      designatedUserId: '', 
      userInfold: '',
      userType: '',
      realName: '',
      phone: '',
      identityName: '',
      goodsId: '', 
      combineId: '', 
      xdbAmount: 0, 
      specArr: [],
      totalCount: 1
    }], // 指定人中奖（合并后的字段）
    prizeAmounts: [{ amount: 0, count: 0 }], // 随机中奖金额列表
    totalUserCount: 0, // 随机中奖人数
    totalXdbAmount: 0, // 总额度
    lookTime: '', // 抽奖门槛（不输入等于不设置）
    signUpFewMinuteStart: '', // 抽奖时间（不输入等于不设置）
    drawFewMinuteStart: '', // 开奖时间
    blessings: '', // 开奖口令
    imgUrl: '', // 直播主图
    liveId: null, // 直播id
    isCanRepeatWinning: 0, // 是否重复中奖 0不允许 1允许
    levelIdsWinning: '', // 获奖等级ID集合(英文逗号隔开，业务线|customer_level)
    selectedIdentityIds: [] // 选中的身份ID数组（用于界面显示）
  }
  return formBean
}

export default {
  props: ['liveId'],
  components: { ImageUpload },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        type: [{ required: true, message: '请选择福袋类型', trigger: 'change' }],
        getType: [{ required: true, message: '请选择分配类型', trigger: 'change' }],
        totalUserCount: [{ required: true, message: '请输入中奖名额', trigger: 'blur' }],
        // 抽奖门槛：如果输入，必须是大于0的正整数
        lookTime: [
          {
            validator: (rule, value, callback) => {
              if (value === '' || value === null || value === undefined || value === 0) {
                callback()
                return
              }
              const num = Number(value)
              if (isNaN(num) || num <= 0 || !Number.isInteger(num)) {
                callback(new Error('请输入大于0的正整数'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        // 抽奖时间：如果输入，必须是大于0的正整数
        signUpFewMinuteStart: [
          {
            validator: (rule, value, callback) => {
              if (value === '' || value === null || value === undefined || value === 0) {
                callback()
                return
              }
              const num = Number(value)
              if (isNaN(num) || num <= 0 || !Number.isInteger(num)) {
                callback(new Error('请输入大于0的正整数'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        // 开奖时间：必填，必须是大于1的正整数
        drawFewMinuteStart: [
          { required: true, message: '请输入开奖时间', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value && value !== 0) {
                callback(new Error('请输入开奖时间'))
                return
              }
              const num = Number(value)
              if (isNaN(num) || num <= 0 || !Number.isInteger(num)) {
                callback(new Error('请输入大于0的正整数'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        // 抽奖权限：随机抽奖时必填
        levelIdsWinning: [
          {
            validator: (rule, value, callback) => {
              // 只有当抽奖分配为随机（getType === 1）时才验证
              if (this.form.getType === 1) {
                // 检查 selectedIdentityIds 数组是否至少有一个元素
                if (!this.form.selectedIdentityIds || this.form.selectedIdentityIds.length === 0) {
                  callback(new Error('请选择抽奖权限'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        // 重复中奖：随机抽奖时必填
        isCanRepeatWinning: [
          {
            validator: (rule, value, callback) => {
              // 只有当抽奖分配为随机（getType === 1）时才验证
              if (this.form.getType === 1) {
                if (value === undefined || value === null || value === '') {
                  callback(new Error('请设置重复中奖'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
      },
      isRepSub: false,
      sysGoods: [], // 商品列表
      sysGoodsLoading: false,
      sysGoodsLoaded: false,
      sysGoodsLoadError: '',
      userList: [], // 用户列表
      loading: false, // 加载中
      // 身份列表
      identityList: [], // 身份列表
      allIdentityList: [] // 所有身份列表
    }
  },
  computed: {
    goodsCatalogReady() {
      return this.sysGoodsLoaded && !this.sysGoodsLoading && !this.sysGoodsLoadError && this.sysGoods.length > 0
    }
  },
  created() {
    // 获取商品列表和用户列表
    this.getSysGoods()
    // 加载身份列表
    this.loadIdentityList()
    // this.getUserList()
  },
  methods: {
    // 获取商品列表
    async getSysGoods() {
      // 首次挂载和打开表单共享在途请求；重试只更新目录，不重置用户草稿。
      if (this.sysGoodsLoading) return
      this.sysGoodsLoading = true
      this.sysGoodsLoaded = false
      this.sysGoodsLoadError = ''
      try {
        const { data } = await sysGoodsApi.getGoodRecomList()
        if (!Array.isArray(data)) throw new Error('商品目录数据异常')
        this.sysGoods = data
        this.sysGoodsLoaded = true
      } catch (error) {
        this.sysGoodsLoadError = '商品目录加载失败，请重试'
      } finally {
        this.sysGoodsLoading = false
      }
    },
    // 获取用户列表
    getUserList(query) {
      liveManageApi.searchUser({ keyword: query }).then(({ data }) => {
        this.userList = data;
      })
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.getUserList(query)
        }, 500);
      } else {
        this.userList = [];
      }
    },
    // 加载身份列表
    loadIdentityList() {
      try {
        const levelList = JSON.parse(localStorage.getItem("levelList")) || [];
        this.allIdentityList = levelList.map(level => ({
          id: level.id,
          name: level.name,
          level: level.level,
          userType: 20 // 业务线
        }));

        // 只显示指定的身份：研修班、体验班、大区（包含大区经理）、地区（包含地区经理）、县区（包含县区经理）
        const allowedIdentityNames = ['研修班', '体验班', '大区经理', '地区经理', '县区经理'];
        this.identityList = this.allIdentityList.filter(identity => {
          // 精确匹配或包含关键词匹配（大区、地区、县区）
          return allowedIdentityNames.includes(identity.name) || 
                 (identity.name && (
                   identity.name.includes('大区') || 
                   identity.name.includes('地区') || 
                   identity.name.includes('县区')
                 ));
        });
      } catch (error) {
        console.error("加载身份列表失败:", error);
        this.identityList = [];
        this.allIdentityList = [];
      }
    },
    // 处理抽奖权限身份选择变化
    handleIdentitySelectionChange() {
      // 将选中的身份ID数组转换为逗号分隔的字符串
      if (this.form.selectedIdentityIds && this.form.selectedIdentityIds.length > 0) {
        this.form.levelIdsWinning = this.form.selectedIdentityIds.join(',');
      } else {
        this.form.levelIdsWinning = '';
      }
    },
    // 处理中奖人身份变化
    handleWinnerIdentityChange(item, idx) {
      // 清空该行的用户选择
      item.selectedUser = null;
      item.userOptions = [];
      item.designatedUserId = '';
      item.userInfold = '';
      item.userType = '';
      item.realName = '';
      item.phone = '';
      item.identityName = '';
    },
    // 搜索中奖人用户（每行独立）
    searchWinnerUser(query, idx) {
      const item = this.form.winners[idx];
      if (!item) return;
      
      if (query !== "") {
        this.$set(item, 'searchLoading', true);
        this.$set(item, 'searchKeyword', query);
        this.getWinnerUserList(item, idx);
      } else {
        // 如果搜索为空，清空选项
        this.$set(item, 'searchKeyword', "");
        this.$set(item, 'userOptions', []);
        this.$set(item, 'searchLoading', false);
      }
    },
    // 获取中奖人用户列表
    getWinnerUserList(item, idx) {
      if (!item.identityId) {
        this.$set(item, 'searchLoading', false);
        return;
      }
      
      const params = {
        keywords: item.searchKeyword || ""
      };
      // 如果选择了身份，添加 CLevel 参数
      if (item.identityId) {
        params.CLevel = item.identityId;
      }
      
      customerApi
        .listForMini(params)
        .then(({ data }) => {
          const arr = [];
          // 获取当前选择的身份信息
          const identity = this.identityList.find(
            idItem => idItem.level === item.identityId
          );
          const identityName = identity ? identity.name : "";
          const userType = identity ? identity.userType : 20;

          data.forEach(it => {
            // 过滤掉姓名为 null 或空字符串的项
            if (!it.name || it.name === "null" || it.name.trim() === "") {
              return;
            }
            const phone = it.pho || "";
            const displayValue = `${it.name}${
              identityName ? `(${identityName})` : ""
            }${phone}`;
            arr.push({
              value: displayValue,
              id: it.id,
              userId: it.userId,
              userInfold: it.id, // 用户资料ID
              userType: userType, // 根据身份确定用户类型
              phone: it.pho,
              realName: it.name
            });
          });
          this.$set(item, 'userOptions', arr);
        })
        .finally(() => {
          this.$set(item, 'searchLoading', false);
        });
    },
    // 处理中奖人用户选择变化（单个用户，已废弃）
    handleWinnerUserChange(item, idx) {
      if (item.selectedUser) {
        item.designatedUserId = item.selectedUser.userId || item.selectedUser.userInfold;
        item.userInfold = item.selectedUser.userInfold;
        item.userType = item.selectedUser.userType;
        item.realName = item.selectedUser.realName;
        item.phone = item.selectedUser.phone;
        // 获取身份名称
        const identity = this.identityList.find(idItem => idItem.level === item.identityId);
        item.identityName = identity ? identity.name : '';
      } else {
        item.designatedUserId = '';
        item.userInfold = '';
        item.userType = '';
        item.realName = '';
        item.phone = '';
        item.identityName = '';
      }
    },
    // 处理中奖人用户选择变化（多个用户）
    handleWinnerUsersChange(item, idx) {
      // 当选择了用户时，设置 designatedUserId 为第一个用户的ID（用于表单验证）
      if (item.selectedUsers && item.selectedUsers.length > 0) {
        const firstUser = item.selectedUsers[0];
        item.designatedUserId = firstUser.userId || firstUser.userInfold;
        // 触发验证
        this.$nextTick(() => {
          this.$refs.dataForm.validateField(`winners[${idx}].designatedUserId`);
        });
      } else {
        item.designatedUserId = '';
        // 触发验证
        this.$nextTick(() => {
          this.$refs.dataForm.validateField(`winners[${idx}].designatedUserId`);
        });
      }
    },
    // 福袋类型改变
    handleTypeChange() {
      this.form.items = [{ goodsId: '', combineId: '', totalCount: 0, price: 0 }]
      if (this.form.type === 1) {
        this.form.winners = [{ 
          identityId: '',
          selectedUser: null,
          selectedUsers: [], // 多选用户数组
          userOptions: [],
          searchLoading: false,
          searchKeyword: '',
          designatedUserId: '', 
          userInfold: '',
          userType: '',
          realName: '',
          phone: '',
          identityName: '',
          goodsId: '', 
          combineId: '', 
          xdbAmount: 0, 
          specArr: [],
          totalCount: 1
        }]
      } else {
        // 零售价福袋：根据getType决定初始化
        if (this.form.getType === 2) {
          // 指定人中奖：需要身份相关字段
          this.form.winners = [{ 
            identityId: '',
            selectedUser: null,
            selectedUsers: [], // 多选用户数组
            userOptions: [],
            searchLoading: false,
            searchKeyword: '',
            designatedUserId: '', 
            userInfold: '',
            userType: '',
            realName: '',
            phone: '',
            identityName: '',
            goodsId: '', 
            xdbAmount: 0
          }]
        } else {
          // 随机中奖：简单初始化
          this.form.winners = [{ designatedUserId: 0, goodsId: 0, xdbAmount: 0 }]
        }
      }
      this.form.prizeAmounts = [{ amount: 0, count: 0 }]
      this.calculateTotalAmount()
    },
    // 分配方式改变
    handleDistributionChange() {
      if (this.form.getType === 2) {
        // 切换到指定人中奖时，清空抽奖权限
        this.form.selectedIdentityIds = []
        this.form.levelIdsWinning = ''
        
        if (this.form.type === 1) {
          // 商品福袋：需要 combineId 和 specArr
          this.form.winners = [{ 
            identityId: '',
            selectedUser: null,
            selectedUsers: [], // 多选用户数组
            userOptions: [],
            searchLoading: false,
            searchKeyword: '',
            designatedUserId: '', 
            userInfold: '',
            userType: '',
            realName: '',
            phone: '',
            identityName: '',
            goodsId: '', 
            combineId: '', 
            xdbAmount: 0, 
            specArr: [],
            totalCount: 1
          }]
        } else {
          // 零售价福袋：需要身份相关字段
          this.form.winners = [{ 
            identityId: '',
            selectedUser: null,
            selectedUsers: [], // 多选用户数组
            userOptions: [],
            searchLoading: false,
            searchKeyword: '',
            designatedUserId: '', 
            userInfold: '',
            userType: '',
            realName: '',
            phone: '',
            identityName: '',
            goodsId: '', 
            xdbAmount: 0,
            totalCount: 1
          }]
        }
      } else {
        // 切换到随机类型时，默认不允许重复中奖（但支持修改）
        this.form.isCanRepeatWinning = 0
        this.form.totalUserCount = 0
        this.form.prizeAmounts = [{ amount: 0, count: 0 }]
      }
      this.calculateTotalAmount()
      // 切换分配方式后，触发抽奖权限和重复中奖的验证
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.validateField('levelIdsWinning')
          this.$refs.dataForm.validateField('isCanRepeatWinning')
        }
      })
    },
    // 添加商品项
    handleAddItem() {
      this.form.items.push({ goodsId: '', combineId: '', totalCount: 0, price: 0 })
    },
    // 删除商品项
    handleDeleteItem(index) {
      this.form.items.splice(index, 1)
      this.calculateTotalAmount()
    },
    // 添加中奖人
    handleAddWinner() {
      if (this.form.type === 1) {
        // 商品福袋：需要 goodsId 和 combineId
        this.form.winners.push({ 
          identityId: '',
          selectedUser: null,
          selectedUsers: [], // 多选用户数组
          userOptions: [],
          searchLoading: false,
          searchKeyword: '',
          designatedUserId: '', 
          userInfold: '',
          userType: '',
          realName: '',
          phone: '',
          identityName: '',
          goodsId: '', 
          combineId: '', 
          xdbAmount: 0, 
          specArr: [],
          totalCount: 1 // 默认1
        })
      } else {
        // 零售价福袋
        if (this.form.getType === 2) {
          // 指定人中奖：需要身份相关字段
          this.form.winners.push({ 
            identityId: '',
            selectedUser: null,
            selectedUsers: [], // 多选用户数组
            userOptions: [],
            searchLoading: false,
            searchKeyword: '',
            designatedUserId: '', 
            userInfold: '',
            userType: '',
            realName: '',
            phone: '',
            identityName: '',
            goodsId: '', 
            xdbAmount: 0 ,
            totalCount: 1
          })
        } else {
          // 随机中奖：简单初始化
          this.form.winners.push({ designatedUserId: 0, goodsId: 0, xdbAmount: 0 })
        }
      }
    },
    // 删除中奖人
    handleDeleteWinner(index) {
      this.form.winners.splice(index, 1)
      this.calculateTotalAmount()
    },
    // 添加中奖金额
    handleAddPrizeAmount() {
      this.form.prizeAmounts.push({ amount: 0, count: 0 })
    },
    // 删除中奖金额
    handleDeletePrizeAmount(index) {
      this.form.prizeAmounts.splice(index, 1)
      this.calculateTotalAmount()
    },
    // 商品选择改变
    handleChange(item) {
      let find = this.sysGoods.find(it => it.id === item.goodsId)
      item.specArr = find ? find.specValueList : []
      // REQ-2026-234328 产品规格优先，回退老的自由文本「商品规格」——
      // 字段名叫 productSpec 却只取 spec，页面上就永远显示不出产品规格（与 gift.vue 口径对齐）
      item.productSpec = find ? (find.productSpec || find.spec) : ''
      item.price = find ? find.price : ''
      if (item.specArr && item.specArr.length === 1) {
        this.$set(item, 'combineId', item.specArr[0].id)
      } else {
        this.$set(item, 'combineId', null)
      }
      this.calculateTotalAmount()
    },
    // 规格选择改变
    handleChangeSpec(item) {
      this.calculateTotalAmount()
    },
    // 中奖名额中的商品选择改变
    handleWinnerGoodsChange(item) {
      let find = this.sysGoods.find(it => it.id === item.goodsId)
      item.specArr = find ? find.specValueList : []
      // REQ-2026-234328 产品规格优先，回退老的自由文本「商品规格」——
      // 字段名叫 productSpec 却只取 spec，页面上就永远显示不出产品规格（与 gift.vue 口径对齐）
      item.productSpec = find ? (find.productSpec || find.spec) : ''
      item.price = find ? find.price : ''
      if (item.specArr && item.specArr.length === 1) {
        this.$set(item, 'combineId', item.specArr[0].id)
      } else {
        this.$set(item, 'combineId', null)
      }
      this.calculateTotalAmount()
    },
    // 中奖名额中的规格选择改变
    handleWinnerSpecChange(item) {
      this.calculateTotalAmount()
    },
    // 计算总额度和中奖名额
    calculateTotalAmount() {
      // 计算中奖名额 totalUserCount
      if (this.form.type === 1) {
        // 商品福袋
        if (this.form.getType === 1) {
          // 随机类型：累加商品中奖名额
          let totalUserCount = 0
          if (this.form.items && this.form.items.length > 0) {
            this.form.items.forEach(item => {
              const count = parseInt(item.totalCount) || 0
              totalUserCount += count
            })
          }
          this.form.totalUserCount = totalUserCount
        } else if (this.form.getType === 2) {
          // 指定人员：统计指定人数
          let totalUserCount = 0
          if (this.form.winners && this.form.winners.length > 0) {
            this.form.winners.forEach(winner => {
              if (winner.selectedUsers && winner.selectedUsers.length > 0) {
                // 多选用户：累加用户数量
                totalUserCount += winner.selectedUsers.length
              } else if (winner.designatedUserId) {
                // 单选用户：累加1
                totalUserCount += 1
              }
            })
          }
          this.form.totalUserCount = totalUserCount
        }
        // 商品福袋不需要计算总额度
        this.form.totalXdbAmount = 0
      } else if (this.form.type === 2) {
        // 零售价福袋
        if (this.form.getType === 1) {
          // 随机中奖：中奖金额 = 累加(中奖零售价 * 中奖名额)
          let totalAmount = 0
          let totalUserCount = 0
          if (this.form.prizeAmounts && this.form.prizeAmounts.length > 0) {
            this.form.prizeAmounts.forEach(item => {
              const amount = parseFloat(item.amount) || 0
              const count = parseInt(item.count) || 0
              totalAmount += amount * count
              totalUserCount += count // 累加中奖名额
            })
          }

          this.form.totalXdbAmount = totalAmount.toFixed(2)
          this.form.totalUserCount = totalUserCount // 设置中奖人数为中奖名额累加
        } else if (this.form.getType === 2) {
          // 指定人中奖：总额度就是中奖名额中的中奖零售价相加，中奖名额是指定人数统计
          let totalAmount = 0
          let totalUserCount = 0

          this.form.winners.forEach(item => {
            if (item.xdbAmount && !isNaN(parseFloat(item.xdbAmount))) {
              totalAmount += parseFloat(item.xdbAmount)
            }
            // 统计指定人数
            if (item.selectedUsers && item.selectedUsers.length > 0) {
              // 多选用户：累加用户数量
              totalUserCount += item.selectedUsers.length
            } else if (item.designatedUserId) {
              // 单选用户：累加1
              totalUserCount += 1
            }
          })

          this.form.totalXdbAmount = totalAmount.toFixed(2)
          this.form.totalUserCount = totalUserCount
        }
      }
    },
    // ... existing code ...
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.getSysGoods()
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      // 处理抽奖权限数据回显：将 levelIdsWinning 字符串转换为数组
      if (this.form.levelIdsWinning && typeof this.form.levelIdsWinning === 'string') {
        this.form.selectedIdentityIds = this.form.levelIdsWinning.split(',').map(id => parseInt(id)).filter(id => !isNaN(id));
      } else {
        this.form.selectedIdentityIds = [];
      }
      // 确保 isCanRepeatWinning 有默认值
      if (this.form.isCanRepeatWinning === undefined || this.form.isCanRepeatWinning === null) {
        this.form.isCanRepeatWinning = 0;
      }
      this.formVisible = true
      this.getSysGoods()
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    ensureGoodsCatalogForSubmit(type = this.form.type) {
      if (type !== 1 || this.goodsCatalogReady) return true
      const message = this.sysGoodsLoadError
        ? '商品目录加载失败，请重试后确认'
        : (this.sysGoodsLoading || !this.sysGoodsLoaded)
          ? '商品目录正在加载，请稍后确认'
          : '暂无可用商品，无法保存商品福袋'
      this.$message.error(message)
      return false
    },
    doCreate() {
      if (!this.ensureGoodsCatalogForSubmit()) return
      this.$refs["dataForm"].validate((valid) => {
        if (!valid) {
          // 表单验证失败，显示错误提示
          this.$message.error('请填写完整的表单信息')
          return false
        }
        if (!this.ensureGoodsCatalogForSubmit()) return
        if (this.isRepSub) return
        this.isRepSub = true
        let params = JSON.parse(JSON.stringify(this.form))
        params.liveId = this.liveId
        
        // 确保 items 存在
        if (!params.items) {
          params.items = []
        }
        
        // 处理 items 中的字段
        if (params.items && params.items.length > 0) {
          params.items.forEach(item => {
            if(item.specArr) delete item.specArr;
            // 确保 totalCount 是数字类型
            if(item.totalCount) {
              item.totalCount = parseInt(item.totalCount) || 0;
            }
          })
        }
        
        if ((this.form.type === 1 && this.form.getType === 2)) {
          // 商品福袋指定人中奖：将winners转换为items，每个winner对应一条item，totalCount默认为1
          // 如果winner有多个用户（selectedUsers），需要为每个用户创建一条记录
          const winnerItems = [];
          (params.winners || []).forEach(winner => {
            if (winner.selectedUsers && winner.selectedUsers.length > 0) {
              // 多选用户：为每个用户创建一条记录
              winner.selectedUsers.forEach(user => {
                winnerItems.push({
                  ...winner,
                  designatedUserId: user.userId || user.userInfold,
                  userInfold: user.userInfold,
                  userType: user.userType,
                  realName: user.realName,
                  phone: user.phone,
                  totalCount: winner.totalCount ? parseInt(winner.totalCount) : 1 // 默认1
                });
              });
            } else if (winner.designatedUserId && !winner.selectedUsers) {
              // 单选用户：直接使用（确保没有selectedUsers时才使用designatedUserId）
              winnerItems.push({
                ...winner,
                totalCount: winner.totalCount ? parseInt(winner.totalCount) : 1 // 默认1
              });
            }
          });
          // 商品福袋指定人中奖时，直接用winnerItems替换items，不合并
          params.items = winnerItems;
        } else if (this.form.type === 2) {
          if (this.form.getType === 1) {
            // 随机中奖：将 prizeAmounts 转换为 items，同时保留 prizeAmounts
            params.items = (params.prizeAmounts || []).map(item => ({
              xdbAmount: parseFloat(item.amount) || 0,
              totalCount: parseInt(item.count) || 0
            }))
            // 处理 prizeAmounts 中的数字字段，确保 count 被正确传递
            if (params.prizeAmounts && Array.isArray(params.prizeAmounts)) {
              params.prizeAmounts = params.prizeAmounts.map(item => ({
                amount: item.amount ? parseFloat(item.amount) : 0,
                count: item.count ? parseInt(item.count) : 0
              }))
              // 计算 totalUserCount：累加所有中奖名额（如果传入的totalUserCount为空或0，才重新计算）
              if (!params.totalUserCount || params.totalUserCount === 0) {
                params.totalUserCount = params.prizeAmounts.reduce((sum, item) => {
                  return sum + (parseInt(item.count) || 0)
                }, 0)
              }
            }
          } else {
            // 指定人中奖：将winners转换为items，如果winner有多个用户（selectedUsers），需要为每个用户创建一条记录
            const winnerItems = [];
            (params.winners || []).forEach(winner => {
              if (winner.selectedUsers && winner.selectedUsers.length > 0) {
                // 多选用户：为每个用户创建一条记录
                winner.selectedUsers.forEach(user => {
                  winnerItems.push({
                    ...winner,
                    designatedUserId: user.userId || user.userInfold,
                    userInfold: user.userInfold,
                    userType: user.userType,
                    realName: user.realName,
                    phone: user.phone,
                    xdbAmount: winner.xdbAmount ? parseFloat(winner.xdbAmount) : 0
                  });
                });
              } else if (winner.designatedUserId && !winner.selectedUsers) {
                // 单选用户：直接使用（确保没有selectedUsers时才使用designatedUserId）
                winnerItems.push({
                  ...winner,
                  xdbAmount: winner.xdbAmount ? parseFloat(winner.xdbAmount) : 0
                });
              }
            });
            params.items = winnerItems;
          }
        }
        
        // 统一处理 items，确保每个 item 都包含所有必需字段
        if (params.items && Array.isArray(params.items)) {
          params.items = params.items.map(item => {
            // 清理不需要的字段
            const cleanItem = { ...item };
            delete cleanItem.specArr;
            delete cleanItem.selectedUser;
            delete cleanItem.selectedUsers; // 删除多选用户数组
            delete cleanItem.userOptions;
            delete cleanItem.searchLoading;
            delete cleanItem.searchKeyword;
            delete cleanItem.identityId;
            delete cleanItem.userInfold;
            delete cleanItem.userType;
            delete cleanItem.realName;
            delete cleanItem.phone;
            delete cleanItem.identityName;
            
            const newItem = {
              blessingBagId: cleanItem.blessingBagId || (this.form.id || null),
              combineId: cleanItem.combineId ? parseInt(cleanItem.combineId) : (cleanItem.combineId || null),
              designatedUserId: cleanItem.designatedUserId ? parseInt(cleanItem.designatedUserId) : (cleanItem.designatedUserId || null),
              goodsId: cleanItem.goodsId ? parseInt(cleanItem.goodsId) : (cleanItem.goodsId || null),
              totalCount: cleanItem.totalCount ? parseInt(cleanItem.totalCount) : (this.form.type === 1 && this.form.getType === 2 ? 1 : (cleanItem.totalCount || 0)),
              xdbAmount: cleanItem.xdbAmount ? parseFloat(cleanItem.xdbAmount) : (cleanItem.xdbAmount || 0)
            }
            return newItem
          })
        }
        
        // 确保其他数字字段也是数字类型
        if(params.totalUserCount) {
          params.totalUserCount = parseInt(params.totalUserCount) || 0;
        }
        if(params.totalXdbAmount) {
          params.totalXdbAmount = parseFloat(params.totalXdbAmount) || 0;
        }
        
        // 处理 winners 中的数字字段
        if(params.winners && Array.isArray(params.winners)) {
          params.winners.forEach(winner => {
            if(winner.xdbAmount) {
              winner.xdbAmount = parseFloat(winner.xdbAmount) || 0;
            }
          });
        }
        params.signUpFewMinuteStart = params.signUpFewMinuteStart ? +params.signUpFewMinuteStart : 0
        params.drawFewMinuteStart = params.drawFewMinuteStart ? +params.drawFewMinuteStart : 0
        params.lookTime = params.lookTime ? +params.lookTime : 0
        
        // 处理抽奖权限和重复中奖字段
        // 确保 levelIdsWinning 是字符串格式（逗号分隔的ID）
        if (params.selectedIdentityIds && Array.isArray(params.selectedIdentityIds) && params.selectedIdentityIds.length > 0) {
          params.levelIdsWinning = params.selectedIdentityIds.join(',');
        } else if (!params.levelIdsWinning) {
          params.levelIdsWinning = '';
        }
        // 删除临时字段 selectedIdentityIds（仅用于界面显示）
        delete params.selectedIdentityIds;
        // 确保 isCanRepeatWinning 是数字类型
        // 指定人中奖时，默认允许重复中奖
        if (this.form.getType === 2) {
          params.isCanRepeatWinning = 1;
        } else {
          // 随机类型：使用用户选择的值，如果没有则默认为0（不允许）
          if (params.isCanRepeatWinning === undefined || params.isCanRepeatWinning === null) {
            params.isCanRepeatWinning = 0;
          } else {
            params.isCanRepeatWinning = parseInt(params.isCanRepeatWinning) || 0;
          }
        }
     
        
        // 判断是编辑还是新建：更严格的判断
        const isEdit = this.form.id && (this.form.id > 0 || String(this.form.id) !== '0')

        // 福袋发出后不能撤回，提交前让中控再核对一遍
        this.$confirm(this.buildLuckyBagSummary(params), isEdit ? '确认修改福袋' : '确认发放福袋', {
          confirmButtonText: isEdit ? '确认修改' : '确认发放',
          cancelButtonText: '再改改',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'lucky-bag-confirm'
        }).then(() => {
          if (!this.ensureGoodsCatalogForSubmit(params.type)) {
            this.isRepSub = false
            return
          }
          if (isEdit) {
            liveBlessingBagApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
              this.$message.error(res.message || '更新失败，请重试')
            });
          } else {
            liveBlessingBagApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
              this.$message.error(res.message || '创建失败，请重试')
            });
          }
        }).catch(() => {
          // 中控取消，放开防重复提交，允许改完再交
          this.isRepSub = false
        })
      });
    },
    /**
     * 拼发放前的核对摘要
     */
    buildLuckyBagSummary(params) {
      const esc = (v) => String(v == null ? '' : v)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      const rows = []
      const add = (label, value) => rows.push(
        `<li><span class="lb-label">${label}</span><span class="lb-value">${esc(value)}</span></li>`
      )

      const isGoodsBag = params.type === 1
      const isDesignated = params.getType === 2
      add('福袋类型', isGoodsBag ? '商品福袋' : '零售价福袋')
      add('抽奖分配', isDesignated ? '指定人中奖' : '随机')

      // 指定人中奖时名额就是指定的人数，随机时用填写的中奖名额
      add('中奖名额', isDesignated
        ? `${(params.items || []).length} 人（指定）`
        : `${params.totalUserCount || 0} 人`)

      if (isGoodsBag) {
        const goodsText = (params.items || []).map(item => {
          const goods = (this.sysGoods || []).find(g => String(g.id) === String(item.goodsId))
          const name = (goods && goods.name) || `商品ID ${item.goodsId}`
          return `${name} ×${item.totalCount || 1}`
        }).join('；')
        add('奖品', goodsText || '未选择商品')
      } else {
        add('零售价中奖总额', `${params.totalXdbAmount || 0} 元`)
      }

      add('抽奖门槛', params.lookTime ? `观看满 ${params.lookTime} 分钟` : '不设置')
      add('抽奖时间', params.signUpFewMinuteStart ? `开播后 ${params.signUpFewMinuteStart} 分钟` : '不设置')
      add('开奖时间', params.drawFewMinuteStart ? `抽奖开始后 ${params.drawFewMinuteStart} 分钟` : '不设置')
      add('开奖口令', params.blessings || '未设置')
      if (!isDesignated) {
        add('重复中奖', Number(params.isCanRepeatWinning) === 1 ? '允许' : '不允许')
      }

      return `<div class="lucky-bag-summary">
        <p class="lb-tip">福袋发出后不可撤回，请核对以下内容：</p>
        <ul>${rows.join('')}</ul>
      </div>`
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    }
  }
}
</script>
<style lang="scss" scoped>
.el-select {
  width: 100%;
}
::v-deep .el-date-editor {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
.form-tip {
  font-size: 12px;
  color: #ff4949;
}
.identity-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  ::v-deep .el-checkbox-button {
    .el-checkbox-button__inner {
      padding: 10px 20px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      background-color: #fff;
      color: #606266;
      transition: all 0.3s;
    }
    &.is-checked .el-checkbox-button__inner {
      background-color: #409eff;
      border-color: #409eff;
      color: #fff;
    }
  }
}
</style>

<!-- 发放确认弹窗挂在 body 下，scoped 样式不生效，这里用 customClass 限定作用域 -->
<style lang="scss">
.lucky-bag-confirm {
  width: 460px;

  .lucky-bag-summary {
    .lb-tip {
      margin: 0 0 12px;
      color: #e6a23c;
      font-weight: 600;
    }

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    li {
      display: flex;
      padding: 6px 0;
      line-height: 20px;
      border-bottom: 1px dashed #ebeef5;

      &:last-child {
        border-bottom: none;
      }
    }

    .lb-label {
      flex: 0 0 100px;
      color: #909399;
    }

    .lb-value {
      flex: 1;
      color: #303133;
      word-break: break-all;
    }
  }
}
</style>
